import Payouts from './Payouts';

export default Payouts;
